import _ from 'lodash'
import { stateCodeToName, stateNameToCode } from '@adc/ui-adc'
import { US_STATES_AND_TERRITORIES_MAPPING } from '../constants/breadcrumbs'

const titleCase = str => {
  const regex = /(?:^|\s|\/|\.)(?!(and|of)\s)\w/g
  return (str || '').toLowerCase().replace(regex, match => match.toUpperCase())
}

export const getStateCode = state => {
  if (!_.isString(state)) return null
  const _state = state.toUpperCase()
  const states = stateNameToCode()
  const stateCode =
    states[_state] ||
    (US_STATES_AND_TERRITORIES_MAPPING[_state] && _state) ||
    null
  return stateCode
}

export const getStateName = state => {
  if (!_.isString(state)) return null
  const _state = state.toUpperCase()
  const states = stateCodeToName()
  const stateName = states[_state] || titleCase(state)
  return stateName
}

export const formatLocation = location => {
  let formattedLocation = ''
  const hasCity = _.get(location, 'city[0]')
  const hasCounty = _.get(location, 'county[0]')
  const hasState = _.get(location, 'state[0]')
  const hasZip = _.get(location, 'zip[0]')
  const stateCode = hasState && getStateCode(location.state[0])
  const stateName = hasState && getStateName(location.state[0])
  if (hasCity) {
    formattedLocation = location.city[0]
    hasState && (formattedLocation += `, ${stateCode}`)
  } else if (hasCounty) {
    formattedLocation = `${location.county[0]} County`
    hasState && (formattedLocation += `, ${stateCode}`)
  } else if (hasState) {
    formattedLocation = stateName
  } else if (hasZip) {
    formattedLocation = location.zip[0]
  }
  return formattedLocation
}

export const formatSeoMetaLocation = location => {
  let formattedLocation = 'US'
  const hasCity = _.get(location, 'city[0]')
  const hasCounty = _.get(location, 'county[0]')
  const hasState = _.get(location, 'state[0]')
  const hasZip = _.get(location, 'zip[0]')
  const stateName = hasState && getStateName(location.state[0])
  const stateCode =
    hasState && getStateCode(location.state[0])
      ? `, ${getStateCode(location.state[0])}`
      : ''
  if (hasCity) {
    formattedLocation = `${location.city[0]}${stateCode}`
  } else if (hasCounty) {
    formattedLocation = `${location.county[0]} County${stateCode}`
  } else if (hasState) {
    formattedLocation = stateName
  } else if (hasZip) {
    formattedLocation = location.zip[0]
  }
  return formattedLocation
}
